import React, { FC, useContext } from "react";
import "./styles.scss";
// import { CustomModalContext } from "../../Contexts/CustomModalContext";

interface IProps {
  title: string,
}

const CompanyContentTitle: FC<IProps> = ({ title }: IProps): JSX.Element => {

  // const { setShowModal } = useContext(CustomModalContext);

  return (
    <div className="ps-company-content-title__container">
      <h3>{title}</h3>
      {/* <img
        onClick={() => setShowModal(true)}
        src="/images/icons/edit-blue-icon.svg"
        alt="edit"
        className="ps-company-content-title__edit-img"
      /> */}
    </div>
  );
};

export default CompanyContentTitle;
